import React, { createContext, useContext, useState } from "react";

import { getUser } from "./local-storage";

export const GlobalContext = createContext({});

export const GlobalProvider = ({ children }) => {
  const [stateGlobal, setStateGlobal] = useState({
    usuario: getUser(),
  });

  return (
    <GlobalContext.Provider value={{ stateGlobal, setStateGlobal }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => useContext(GlobalContext);
